import React from "react";
import styled from "styled-components";
import { GetGradeString, getManagerGrade } from "../../../AdminApi/commFunc";
import useMy from "../../../hooks/useMy";

export default function MyInfoTable() {
  const { grade, name, email } = useMy();

  return (
    <MyInfoTableContainer>
      <MyInfoTableRow>
        <MyInfoTableRowColumn>
          <MyInfoTableRowColumnText>아이디</MyInfoTableRowColumnText>
        </MyInfoTableRowColumn>
        <MyInfoTableRowValue>
          <MyInfoTableRowValueText>{email}</MyInfoTableRowValueText>
        </MyInfoTableRowValue>
      </MyInfoTableRow>

      <MyInfoTableRow>
        <MyInfoTableRowColumn>
          <MyInfoTableRowColumnText>이름</MyInfoTableRowColumnText>
        </MyInfoTableRowColumn>
        <MyInfoTableRowValue>
          <MyInfoTableRowValueText>{name}</MyInfoTableRowValueText>
        </MyInfoTableRowValue>
      </MyInfoTableRow>

      <MyInfoTableRow>
        <MyInfoTableRowColumn>
          <MyInfoTableRowColumnText>등급</MyInfoTableRowColumnText>
        </MyInfoTableRowColumn>
        <MyInfoTableRowValue>
          <MyInfoTableRowValueText>
            {GetGradeString(grade) ?? getManagerGrade(String(grade))}
          </MyInfoTableRowValueText>
        </MyInfoTableRowValue>
      </MyInfoTableRow>
    </MyInfoTableContainer>
  );
}

const MyInfoTableContainer = styled.div`
  width: 100%;
`;

const MyInfoTableRow = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.buttonColor.lineNormal};
  }
`;

const MyInfoTableRowColumn = styled.div`
  width: 110px;
  height: 100%;
  height: 50px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  padding-left: 20px;
`;

const MyInfoTableRowColumnText = styled.span`
  font-weight: bold;
  line-height: 24px;
  text-align: left;
  color: #858c97;
`;

const MyInfoTableRowValue = styled.div`
  width: calc(100% - 110px);
  display: flex;
  align-items: center;
  padding-left: 24px;
`;

const MyInfoTableRowValueText = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  color: #2f2f38;
`;
